import { CommonModule } from '@angular/common'
import { Component, OnInit, Signal, computed, input } from '@angular/core'
import { Data, RouterModule } from '@angular/router'
import { DestroySubscribers, ScreenSize, ScreenSizeService } from '@ftr/foundation'
import { SideNavGroup, SideNavItemsProvider } from '@ftr/ui-core'
import { takeUntil } from 'rxjs'
import { SideNavDisplayComponent } from '~app/core/app-layout/side-nav/side-nav-display.component'
import { TopBarDisplayComponent } from '~app/core/app-layout/top-bar/top-bar-display.component'

@Component({
  selector: 'ftr-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, SideNavDisplayComponent, TopBarDisplayComponent],
})
export class AppLayoutComponent extends DestroySubscribers implements OnInit {
  routeDataSignal = input({} as Data | undefined, { alias: 'routeData' })

  protected expanded: boolean = false
  protected toggledMenu: boolean = false
  protected opened: boolean = false

  protected currentCourtSystemId: Signal<string | undefined> = computed(() => {
    return this.routeDataSignal()?.courtSystemId
  })
  protected navGroups: Signal<{ navGroups: SideNavGroup[] }>

  constructor(
    private screenSizeService: ScreenSizeService,
    private sideNavItemProvider: SideNavItemsProvider,
  ) {
    super()

    this.navGroups = this.sideNavItemProvider.provide(this.currentCourtSystemId)
  }

  ngOnInit(): void {
    this.watchScreenSize()
  }

  handleSidebarToggle(): void {
    this.expanded = !this.expanded
    this.toggledMenu = true
  }

  handleSidebarOpen(forceState?: boolean): void {
    this.opened = forceState !== undefined ? forceState : !this.opened
  }

  private watchScreenSize(): void {
    this.screenSizeService.size.pipe(takeUntil(this.finalize)).subscribe(size => {
      if (!this.toggledMenu) {
        if (size >= ScreenSize.XLarge) {
          this.expanded = true
        }

        if (size === ScreenSize.Large) {
          this.expanded = false
        }
      }

      if (this.opened && size > ScreenSize.Small) {
        this.opened = false
      }
    })
  }
}
